import React, { useState } from "react";
import { useSelector } from "react-redux";
import { Nav, Button } from "react-bootstrap";
import { Link, useLocation } from "react-router-dom";
import {
  FaChevronCircleLeft,
  FaChevronCircleRight,
  FaUserMd,
  FaUsers,
  FaUserShield,
} from "react-icons/fa";

import { PiWatchFill } from "react-icons/pi";

import "./style.css";

const Sidebar = () => {
  const { userType } = useSelector((state) => state.auth)
  const location = useLocation();
  const [collapsed, setCollapsed] = useState(false);
  
  const toggleCollapse = () => setCollapsed(!collapsed);
  const checkIfLinkIsActive = (pathname) => {
    if (
      pathname === "/patient-enrollment" &&
      (location.pathname === "" || location.pathname === "/")
    )
    return true;
    return pathname === location.pathname;
  };
  
  return (
    <div
      className={`d-flex flex-column position-sticky sidebar ${collapsed ? "sidebar-collapsed" : ""
        }`}
    >
      <div className="d-flex flex-row w-100">
        <div className="mt-2 floating-anchor">
          <Button variant="link" onClick={toggleCollapse}>
            {collapsed ? (
              <FaChevronCircleRight size={25} color="#4c4d9d" />
            ) : (
              <FaChevronCircleLeft size={25} color="#4c4d9d" />
            )}
          </Button>
        </div>
      </div>
      <Nav className="flex-column">
        <div className="mt-2">
          <Nav.Link
            as={Link}
            to="/patient-enrollment"
            className={`d-flex align-items-center ${checkIfLinkIsActive("/patient-enrollment") ? "active" : ""
              }`}
          >
            <FaUserShield className="sidebarIcon icon-size" />
            <div className="ms-3 sidebarIcon">{!collapsed && "Patient Enrollment"}</div>
          </Nav.Link>
          {userType.trim() === 'OrgAdmin' ? (
              <Nav.Link
                as={Link}
                to="/care-team"
                className={`d-flex align-items-center ${checkIfLinkIsActive("/care-team") ? "active" : ""
                  }`}
              >
                <FaUserMd className="sidebarIcon icon-size" />
                <div className="ms-3 sidebarIcon">{!collapsed && "Care Team"}</div>
              </Nav.Link>
            )
            : <></>
          }
          <Nav.Link
            as={Link}
            to="/device-management"
            className={`d-flex align-items-center ${checkIfLinkIsActive("/device-management") ? "active" : ""
              }`}
          >
            <PiWatchFill className="sidebarIcon icon-size" />
            <div className="ms-3 sidebarIcon">{!collapsed && "Device Management"}</div>
          </Nav.Link>
          <Nav.Link
            as={Link}
            to="/patient-population"
            className={`d-flex align-items-center ${checkIfLinkIsActive("/patient-population") ? "active" : ""
              }`}
          >
            <FaUsers className="sidebarIcon icon-size" />
            <div className="ms-3 sidebarIcon">{!collapsed && "Patient Population"}</div>
          </Nav.Link>
        </div>
      </Nav>
      <div className="mt-auto p-3 text-body-tertiary text-center">
        {collapsed ? "© UE" : "© LifeLeaf"}
      </div>
    </div>
  );
};

export default Sidebar;
